/** iPhone / iPod / iPad (incl. iPadOS desktop UA). */
export const isAppleTouchDevice = (): boolean => {
  if (typeof navigator === 'undefined') {
    return false;
  }

  const { userAgent, platform, maxTouchPoints } = navigator;

  return (
    /iP(hone|od|ad)/.test(userAgent) ||
    (platform === 'MacIntel' && typeof maxTouchPoints === 'number' && maxTouchPoints > 1)
  );
};
